// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue, { DirectiveFunction } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import App from "./app.vue";
import Vue2Filters from "vue2-filters";
import router from "./router";
import axios from "axios";
import VueMask from "v-mask";
import moment from "moment";
import * as config from "./shared/config/config";
import * as bootstrapVueConfig from "./shared/config/config-bootstrap-vue";
import JhiItemCountComponent from "./shared/jhi-item-count.vue";
import JhiSortIndicatorComponent from "./shared/sort/jhi-sort-indicator.vue";
import InfiniteLoading from "vue-infinite-loading";
import "../content/scss/vendor.scss";
import AlertService from "@/shared/alert/alert.service";
import Element from "element-ui";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import locale from "element-ui/lib/locale/lang/vi";
import "@fortawesome/fontawesome-free/js/all.js";
import "bootstrap";
import FileApi from "./data/api/FileApi";
import LoginApi from "@/data/api/LoginApi";
import HeaderService from "@/presentation/containers/header/header.service";
import DataBCDTService from "@/presentation/view/resources/bcdt/data-bcdt/data-bcdt.service";
import FlowBCDTService from "@/presentation/view/resources/bcdt/flow-bcdt/flow-bcdt.service";
import TelecomLicenseFeeService from "@/presentation/view/resources/IssueADispatch/TelecomLicenseFee/TelecomLicenseFee.service";
import FeeTrackingCCDV from "@/presentation/view/resources/FeeManagementCCDV/FeeTrackingCCDV/FeeTrackingCCDV.service";
import ReceiptDeclarationsService from "@/presentation/view/resources/receipt-fees/receipt-declarations/receiptDeclarations.service";
import ReceiptBCDTService from "@/presentation/view/resources/receipt-bcdt/receipt-bcdt.service";
import ReceiptSettlementService from "@/presentation/view/resources/receipt-fees/receipt-settlement/receiptSettlement.service";
import AccountingLiabilitiesCCDVService from "@/presentation/view/resources/FeeManagementCCDV/AccountingLiabilitiesCCDV/AccountingLiabilitiesCCDV.service";
import AccumulatedDebtCCDVService from "@/presentation/view/resources/FeeManagementCCDV/AccumulatedDebtCCDV/AccumulatedDebtCCDV.service";
import TelecomDebtCCDVService from "@/presentation/view/resources/FeeManagementCCDV/TelecomDebtCCDV/TelecomDebtCCDV.service";
import FeeTrackingTLM from "@/presentation/view/resources/FeeManagementTLM/FeeTrackingTLM/FeeTrackingTML.service";
import AccountingLiabilitiesTLMService from "@/presentation/view/resources/FeeManagementTLM/AccountingLiabilitiesTLM/AccountingLiabilitiesTLM.service";
import AccumulatedDebtTLMService from "@/presentation/view/resources/FeeManagementTLM/AccumulatedDebtTLM/AccumulatedDebtTLM.service";
import IncomeFeeService from "@/presentation/view/resources/IncomeFee/IncomeFee.service";
import OneTimeFeeService from "@/presentation/view/resources/OneTimeFee/OneTimeFee.service";
import DisManageService from "@/presentation/view/resources/DispatchManagement/DisManage.service";
import AdministrativeSanctions from "@/presentation/view/resources/AdministrativeSanctions/AdministrativeSanctions.service";
// company
import CompanyService from "@/presentation/view/resources/Company/company.services";
import FeeCodeListCpnService from "@/presentation/view/resources/WarehouseNo/fee-list/fee-list.service";
import FeeCodeDetailCpnService from "@/presentation/view/resources/WarehouseNo/fee-detail/fee-detail.service";
import FeeNumberService from "@/presentation/view/resources/WarehouseNo/FeeNember/FeeNumber.service";
import FeeTrackingKSService from "@/presentation/view/resources/WarehouseNo/FeeTrackingKS/FeeTrackingKS.service";
import AccountKSService from "@/presentation/view/resources/DebtNoKS/AccountKS/AccountKS.service";
import AclatedKSService from "@/presentation/view/resources/DebtNoKS/AclatedKS/AclatedKS.service";
import TelecoKSService from "@/presentation/view/resources/DebtNoKS/TelecoKS/TelecoKS.service";
import WarehouseDispatchNoSer from "@/presentation/view/resources/IssueADispatch/WarehouseDispatchNo/WarehouseDispatchNo.service";
import "@coreui/icons/css/all.min.css";
import "element-ui/lib/theme-chalk/index.css";
import BootstrapVue from "bootstrap-vue";
import * as Ladda from "ladda";
import DataConvertUtils from "@/commons/DataConvertUtils";
import DebtGeneral from "@/presentation/view/resources/Company/debt-general/debt-general.service";
import HisUrgeComany from "@/presentation/view/resources/Company/his-urge/his-urge.service";
// home
import HomeService from "@/core/home/home.service";
import Editor from "@tinymce/tinymce-vue";
// SeaCable(Cap bien)
import SeaCable from "@/presentation/view/resources/SeaCable/SeaCable.service";
// DeclarationTax Tờ khai thuế
import DeclarationTax from "@/presentation/view/resources/DeclarationTax/DeclarationTax.service";
// SMS-Comp Tin nhắn gửi doanh nghiệp
import SmsCompany from "@/presentation/view/resources/Sms/SmsComp.service";
import HistorySms from "@/presentation/view/resources/History-Sms/History-Sms.service";
// Chi cục thuế
import TaxDepartment from "@/presentation/view/resources/TaxDepartment/TaxDepartment.service";
// Báo cáo doannh thu - theo nămDeclareStatistic
import DeclareStatisticYear from "@/presentation/view/resources/DeclareStatisticYear/DeclareStatisticYear.service";
import DeclareStatisticDayService from "@/presentation/view/resources/DeclareStatisticDay/DeclareStatisticDay.service";
import DeclareStatisticPeopleService from "@/presentation/view/resources/DeclareStatisticPeople/DeclareStatisticPeople.service";

// Mức thu phí, lệ phí
import CollectionRatesService from "@/presentation/view/resources/CollectionRates/CollectionRates.service";
// Danh mục địa danh
import ListPlaceService from "@/presentation/view/resources/ListPlace/ListPlace.service";
Vue.component("editor", Editor);
//el-form
import FromElectronicService from "@/presentation/view/resources/FromElectronic/FromElectronic.service";
// Nhóm quyền
import UserAdService from "@/presentation/view/resources/Admin/UserAdministrator/UserAdministrator.service";
import UserAccount from "@/presentation/view/resources/Admin/UserAccount/UserAccount.service";
import ImpactHistory from "@/presentation/view/resources/Admin/ImpactHistory/ImpactHistory.service";
import CreateAccounts from "@/presentation/view/resources/Admin/UserAccount/CreateAccount/CreateAccount.service";
import PresonalInfo from "@/presentation/view/resources/Admin/PersonalInfo/PersonalInfo.service";

import ToolService from "@/core/tool/tool-import.service";
import SentSlowService from "@/presentation/view/resources/SentSlow/SentSlow.service";

window.Ladda = Ladda;

import ApexCharts from "vue-apexcharts";
Vue.use(ApexCharts);
Vue.component("apexchart", ApexCharts);

Vue.use(VueMask);
// @ts-ignore
Vue.directive("ladda", function LaddaDirectiveOptions(
  el: any,
  binding: any,
  vnode: any
  // @ts-ignore
): DirectiveFunction {
  window.$(el).attr("data-style", "slide-left");
  window.Ladda.bind(el);
});

import $ from "jquery";
declare global {
  interface Window {
    c: any;
    jQuery: any;
    $: any;
    Ladda: any;
    NProgress: any;
    toastr: any;
  }
}
/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("jhi-item-count", JhiItemCountComponent);
Vue.component("jhi-sort-indicator", JhiSortIndicatorComponent);
Vue.component("infinite-loading", InfiniteLoading);
Vue.use(Element, { locale, size: "medium" });
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// ClassicEditor
//     .create( document.querySelector( '#editor' ) )
//     .then( editor => {
//         console.log( editor );
//     } )

//     .catch( error => {
//         console.error( error );
//     } );

const options = {
  editors: {
    classic: ClassicEditor,
  },
  name: "ckeditor",
};
const NProgress = require("nprogress");
NProgress.configure({
  trickleSpeed: 1000,
  minimum: 0.2,
});
window.NProgress = NProgress;

window.toastr = require("toastr");
window.jQuery = window.$ = require("jquery");
window.toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "6000",
  extendedTimeOut: "1000",
  tapToDismiss: false,
};
const store = config.initVueXStore(Vue);
const alertService = new AlertService(store);
const dataConverter = DataConvertUtils.instance;
// Phân quyền
router.beforeEach((to, from, next) => {
  Vue.use(BootstrapVue);
  const user = JSON.parse(localStorage.getItem("user"));
  if (user == null && to.path != "/Login") {
    let loc = window.location;
    loc.href = window.location.origin + "/Login";
  } else if (user == null && to.path == "/Login") {
    next();
  } else {
    if (user && user.expiDate < new Date()) {
      localStorage.removeItem("user");
      let loc = window.location;
      loc.href = window.location.origin + "/Login";
    } else {
      if (user) {
        //new Date().setHours(new Date().getHours() + 12);

        user.expiDate = new Date().setMinutes(new Date().getMinutes() + 30);
        console.log("main user.expiDate:" + user.expiDate);
        localStorage.setItem("user", JSON.stringify(user));
      }
      // get meta in to
      let arrayRole = to.meta.authorities ? to.meta.authorities : [];
      let role;
      // let role = checkRole(arrayRole,user)
      arrayRole.forEach((element) => {
        user.roles_detail.forEach((element1) => {
          let obj = element1.features.find((x) => x.id == element);
          if (obj) {
            role = obj.id;
          }
        });
      });

      if (role) {
        next();
      } else {
        if (to.path == "/not-found") next();
        else {
          next("not-found");
        }
      }
    }
  }
});
// $( document ).ready(function() {
//   console.log( "document loaded" );
//   $(document).on('click', '.el-date-editor--date .el-input__inner', function(){
//     // get value
//     $(this).change(function() {
//       let value = $(this).val();
//       // check invalid date in moment
//       if (moment(value).format("YYYY-MM-DD") == "Invalid date") {
//         console.log("valid",value);
//         // set value input null
//         // $(this).val("")[0].dispatchEvent(new Event('input'))
//         const originalParseFunction = $(this).val().parseString
//         $(this).val().parseString = function (value) {
//           return originalParseFunction(value)
//         }
//         // update value
//       }
//   });
//    });
// });

/* tslint:disable */
(window as any).vm = new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  router,
  provide: {
    fileApi: () => new FileApi(),
    loginApi: () => new LoginApi(),
    headerService: () => new HeaderService(),
    alertService: () => alertService,
    dataBCDTService: () => new DataBCDTService(),
    flowBCDTService: () => new FlowBCDTService(),
    telecomLicenseFeeService: () => new TelecomLicenseFeeService(),
    feeTrackingCCDV: () => new FeeTrackingCCDV(),
    receiptBCDTService: () => new ReceiptBCDTService(),
    receiptDeclarationsService: () => new ReceiptDeclarationsService(),
    receiptSettlementService: () => new ReceiptSettlementService(),
    feeTrackingTLM: () => new FeeTrackingTLM(),
    accountingLiabilitiesCCDVService: () => new AccountingLiabilitiesCCDVService(),
    accumulatedDebtCCDVService: () => new AccumulatedDebtCCDVService(),
    telecomDebtCCDVService: () => new TelecomDebtCCDVService(),
    accountingLiabilitiesTLMService: () => new AccountingLiabilitiesTLMService(),
    accumulatedDebtTLMService: () => new AccumulatedDebtTLMService(),
    companyService: () => new CompanyService(),
    feeNumberService: () => new FeeNumberService(),
    feeTrackingKSService: () => new FeeTrackingKSService(),
    incomeFeeService: () => new IncomeFeeService(),
    oneTimeFeeService: () => new OneTimeFeeService(),
    feeCodeListCpnService: () => new FeeCodeListCpnService(),
    feeCodeDetailCpnService: () => new FeeCodeDetailCpnService(),
    accountKSService: () => new AccountKSService(),
    aclatedKSService: () => new AclatedKSService(),
    telecoKSService: () => new TelecoKSService(),
    warehouseDispatchNoSer: () => new WarehouseDispatchNoSer(),
    debtGeneral: () => new DebtGeneral(),
    hisUrgeComany: () => new HisUrgeComany(),
    fromElectronicService: () => new FromElectronicService(),
    homeService: () => new HomeService(),
    disManageService: () => new DisManageService(),
    seaCable: () => new SeaCable(),
    declarationTax: () => new DeclarationTax(),
    smsCompany: () => new SmsCompany(),
    historySms: () => new HistorySms(),
    taxDepartmentService: () => new TaxDepartment(),
    collectionRatesService: () => new CollectionRatesService(),
    listPlaceService: () => new ListPlaceService(),
    userAdService: () => new UserAdService(),
    administrativeSanctions: () => new AdministrativeSanctions(),
    userAccount: () => new UserAccount(),
    createAccounts: () => new CreateAccounts(),
    impactHistory: () => new ImpactHistory(),
    declareStatisticYear: () => new DeclareStatisticYear(),
    declareStatisticDayService: () => new DeclareStatisticDayService(),
    declareStatisticPeopleService: () => new DeclareStatisticPeopleService(),
    sentSlowService: () => new SentSlowService(),
    presonalInfo: () => new PresonalInfo(),

    toolService: () => new ToolService(),
  },
  store,
});
